import { Card } from '@nextui-org/react';

import Bismillah from '../components/Bismillah';
import CardPageContainer from '../components/CardPageContainer';
import Footer from '../components/Footer';
import Header from '../components/Header';
import InnerCardPageContainer from '../components/InnerCardPageContainer';
import Layout from '../components/Layout';

export default function About() {
  return (
    <Layout>
      <Header description="About the Thaqalayn Hadith Library" title="About Thaqalayn" />
      <CardPageContainer>
        <InnerCardPageContainer>
          <Card className="single-card" role="article">
            <div className="card-body mt-2 mb-2">
              <Bismillah />
              <h1 className="text-xl font-bold">About Thaqalayn - Shia Hadith Library</h1>
              <p>
                Thaqalayn Hadith Library is your source for exploring the classical hadith tradition of the Imāmī Shia
                Muslim school of thought. We believe that access to primary historical sources is a fundamental right,
                and our goal is to make it easier for everyone to access and study these important sources of faith and
                wisdom. Our website indexes a wide range of classical Imāmī hadith texts, including well-known
                collections and lesser-known works, from various scholars and transmitters. We use already available
                translations to make these texts available in Arabic and English side by side. We hope that this in
                combination with the versatile search engine can turn this platform to an aid for English speaking
                researchers, students and scholars.
              </p>
              <br />
              <p>
                It&apos;s important to note that the texts on this website are presented for educational and academic
                purposes only. The views and interpretations contained in these texts may not reflect the views of the
                translators or the website administration. As with any religious or historical text, one should always
                refer to experts in the field to get to know the authenticity or implication of a specific text or book.
              </p>
              <br />
              <p>
                Additionally, it is important to mention that the books included on our website are a curated selection
                under the advice of scholars. We strive to present the most authentic and reliable texts, and have
                consulted with experts in the field to make a humble attempt at this.
              </p>
              <p>
                If you have any question or enquiry regarding the website or the content hosted on this website please
                contact:
                <a href="mailto: info@thaqalayn.net"> info@thaqalayn.net</a>
              </p>
            </div>
          </Card>
        </InnerCardPageContainer>
        <Footer />
      </CardPageContainer>
    </Layout>
  );
}
